// extracted by mini-css-extract-plugin
export default {"loginForm":"loginForm_loginForm__Izqd5","loginForm__action":"loginForm_loginForm__action__viLHT","loginForm__link":"loginForm_loginForm__link__uzV7j"};